import { render, staticRenderFns } from "./addAdvConfig.vue?vue&type=template&id=e2a31c2e&scoped=true"
import script from "./addAdvConfig.vue?vue&type=script&lang=js"
export * from "./addAdvConfig.vue?vue&type=script&lang=js"
import style0 from "./addAdvConfig.vue?vue&type=style&index=0&id=e2a31c2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a31c2e",
  null
  
)

export default component.exports